import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const noteContainer = css`
  margin-inline-start: ${spacing(-1)};
  padding-block-end: ${spacing(1)};
`

export const note = css`
  padding: ${spacing(1.5, 2)};
  background-color: #e7f4e0;
  flex-direction: column;
  width: 100%;
  border-radius: ${spacing(2)};
`
